import { React, useEffect, useState } from "react";
import classes from './Mitigation.module.scss';

//MUI Imports
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function Mitigation({questionValue, riskOptions, mitigationFields, mitigationBody, onUpdate, toolTipOverrides}) {
    
    const [shouldMitigate, setShouldMitigate] = useState(false)
    const [fieldValues, setFieldValues] = useState({})
    const [mitigationFieldsState, setMitigationFieldsState] = useState([])

    function onFieldUpdate(key, value){
        
        let questionValueClone = JSON.parse(JSON.stringify(questionValue))
        
        if(questionValueClone.mitigation === undefined){
            questionValueClone.mitigation = {}
        }

        questionValueClone.mitigation[key] = value;
        onUpdate(questionValueClone.mitigation)

    }

    useEffect(() =>{

        let overiddenMitigationFields = []

        if(toolTipOverrides !== undefined){

            mitigationFields.forEach(element => {
                if( toolTipOverrides[element.key] !== undefined){
                    overiddenMitigationFields.push(
                        {...element, tooltip:toolTipOverrides[element.key]}
                    )
                }
                else{
                    overiddenMitigationFields.push(
                        {...element, tooltip:element.tooltip}
                    )
                }
                
            })

            setMitigationFieldsState(overiddenMitigationFields)

        }else{
            setMitigationFieldsState(mitigationFields)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[mitigationFields])

    useEffect(() =>{
        setShouldMitigate(false)
        if(questionValue !== undefined && questionValue !== null ){
            setFieldValues(questionValue.mitigation)
            
            Object.keys(riskOptions.options).forEach(key => {
                let risk = riskOptions.options[key]
                if(risk.value === questionValue.danger && risk.mitigate){
                    setShouldMitigate(true);
                    return
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [questionValue])
    
    return (
        <>
            {
            shouldMitigate
            ?
                <div className={`${classes.Mitigation} content_wrapper__inner mitigation_accordion`}>
                    <div className={`${classes.Mitigation__title} accordion_padding`}>
                        <p className={`redColor ${classes.Mitigation__content_padding}`}><strong>Mitigating Actions</strong></p>
                    </div>
                    <div className={`${classes.Mitigation__accordion_details} gain_content_container`}>
                        <div className={`${classes.Mitigation__form_container} accordion_padding`}>
                            {
                                mitigationFieldsState.map((element, index) => {
                                    return (
                                        <TextField id="standard-basic" variant="standard"
                                            className={`form_input`}
                                            key={index}
                                            fullWidth
                                            multiline
                                            cols={50}
                                            rows={10}
                                            defaultValue={(fieldValues !== undefined ? fieldValues[element.key] : "")}
                                            onChange={(e) => {onFieldUpdate(element.key, e.currentTarget.value)}}
                                            InputLabelProps={{ style: { zIndex:2 } }}
                                            label={
                                                <div className={`${classes.Mitigation__text_field_label}`}>
                                                {element.label}
                                                {(
                                                    element.label !== ""?
                                                        <Tooltip title={<span dangerouslySetInnerHTML={{__html:element.tooltip}}/>}>
                                                            <InfoOutlinedIcon sx={{
                                                                height:"20px",
                                                                width:"20px",
                                                                marginLeft:"8px"
                                                            }} 
                                                            />
                                                        </Tooltip>
                                                        :
                                                        ""
                                                )}
                                                </div>
                                            }
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            :
                ""
            }
        </>
    )
                            

}
export default Mitigation